module.exports = "/_next/static/videos/CARD-b28e95c4e3517550e40c22438fe88b1b.mp4";